import { Box, Button, Typography } from '@mui/material';
import { SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon } from '@mui/icons-material';
import { ApiError, getErrorMessage } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';

export type ErrorCardProps = {
  error: Error;
  onRetryClick: () => void;
};

const ErrorCard = ({ error, onRetryClick }: ErrorCardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <SentimentVeryDissatisfiedIcon sx={{ color: 'error.main', fontSize: '3rem' }} />
      <Typography sx={{ color: 'error.main' }} variant="h4">
        {error instanceof ApiError
          ? error.errorResponseDto.error
          : t('Unknown error', { defaultValue: 'Unknown error ' })}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: (theme) => theme.palette.grey[600],
            fontWeight: 500,
            maxWidth: {
              xs: '80%',
              md: '60%',
              lg: '50%',
            },
          }}
        >
          {error instanceof ApiError
            ? getErrorMessage(error.errorResponseDto.message)
            : t('An unkown error occurred.', { defaultValue: 'An unkown error occurred.' })}
        </Typography>
        <Button
          onClick={onRetryClick}
          type="button"
          variant="contained"
          color="error"
          sx={{ width: '50%', mt: '1.2rem' }}
        >
          {t('Retry', { defaultValue: 'Retry' })}
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorCard;
